<template>
  <div class="logo">
    <router-link key="expand" class="sidebar-logo-link" to="/" @click.native="routerLinkClick">
      <img src="@/assets/images/logo.png" class="sidebar-logo">
    </router-link>
    <span id="applications" class="sidebar-title">
      <img src="../../svg-icons/expand.svg" style="height: 17px" alt="">
      答题卡制作
    </span>
  </div>
</template>

<script>
import Septcuts from 'septcuts'
export default {
  name: 'SidebarLogo',
  components: {
  },
  data() {
    return {
      title: '答题卡制作'
    }
  },
  created() {
    this.getApplications()
  },
  methods: {
    getApplications() {
      // 平台统一 See => https://git.septnet.cn/npm/septcuts
      new Septcuts('#applications', {
        groups: 'https://static.7net.cc/septcuts/septcuts.json',
        http: { url: 'https://static.7net.cc/septcuts/septcuts.json', method: 'post', header: {}, data: {}}, // 接口请求，设置groups未设置时，可设置此项
        cssClass: 'applications',
        // click: (item) => {
        //   this.$get('/UserService/GotoSite', {
        //     role: item.site
        //   }).then(res => {
        //     if (res.status === 200 && res.data) window.location.href = res.data
        //   })
        // }
      })
    },
    routerLinkClick(e) {
      this.$emit('logoClick')
    }
  }
}
</script>

<style type="css">
.applications .list-content {
  width: 600px !important;
}
</style>

<style lang="scss" scoped>
.logo {
  float: left;

  & .sidebar-logo-link {
    padding-left: 50px;

    & .sidebar-logo {
      width: auto;
      height: 56px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }

  & .sidebar-title {
    margin: 0;
    font-weight: 400;
    font-size: 17px;
    vertical-align: middle;
    border-left: 1px solid #222;
    padding: 0 20px 0 20px
  }

  & .sidebar-title:hover {
    color: #1890ff;
    cursor: pointer;
  }
}

</style>
